/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_AllInputs */

const en_whats_new_all = /** @type {(inputs: Whats_New_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All changes`)
};

const de_whats_new_all = /** @type {(inputs: Whats_New_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Änderungen`)
};

/**
* | output |
* | --- |
* | "All changes" |
*
* @param {Whats_New_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_all = /** @type {((inputs?: Whats_New_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_whats_new_all(inputs)
	return en_whats_new_all(inputs)
});